import { render, staticRenderFns } from "./BranchSelect.vue?vue&type=template&id=42e5215c&scoped=true&"
import script from "./BranchSelect.vue?vue&type=script&lang=js&"
export * from "./BranchSelect.vue?vue&type=script&lang=js&"
import style0 from "./BranchSelect.vue?vue&type=style&index=0&id=42e5215c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e5215c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VContainer,VRow,VSelect})
